import { render, staticRenderFns } from "./dynamicTela.vue?vue&type=template&id=55e4679f"
import script from "./dynamicTela.vue?vue&type=script&lang=js"
export * from "./dynamicTela.vue?vue&type=script&lang=js"
import style0 from "./dynamicTela.vue?vue&type=style&index=0&id=55e4679f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports